<template>
  <div class="base-input" :cy="cy || name" :class="`${name}-input`">
    <label :for="name">
      <span>{{ label || name }}</span>
      <span v-if="rule === 'required'">*</span>
    </label>
    <textarea
      v-if="type === 'textarea'"
      :id="name"
      autocapitalize="off"
      :value="value"
      :disabled="disabled"
      @input="handleInput"
      :placeholder="placeholder || label || name"
    />
    <input
      v-else
      :id="name"
      autocapitalize="off"
      :type="type || 'text'"
      :value="value"
      :disabled="disabled"
      @input="handleInput"
      :placeholder="placeholder || label || name"
    />
  </div>
</template>

<script setup>
  const props = defineProps({
    name: String,
    cy: String,
    label: String,
    type: String,
    placeholder: String,
    value: [String, Number, undefined],
    disabled: Boolean,
  });

  const emits = defineEmits(['input']);

  function handleInput (ev) {
    emits('input', { name: props.name, value: ev.target.value });
  }
</script>

<style lang="scss">
  @import "../styles/vars";

  .base-input {
    @media only screen and (min-width: 0) {
      label {
        margin-bottom: 3px;
        display: block;
        font-size: 1.6rem;
      }
      > span {
        margin-top: 4px;
        margin-bottom: 14px;
        display: inline-block;
        color: $red;
        font-size: 1.4rem;
      }
      input,
      textarea {
        padding: 8px 0 8px 12px;
        font-size: 1.8rem;
        border: 1px solid lightgray;
        border-radius: 4px;
      }
      textarea {
        width: 100%;
        min-height: 80px;
        resize: vertical;
      }
    }
  }
</style>
